
  import { Vue, Component, Prop } from "vue-property-decorator";

  import AllDocumentsSearchableList from "@/components/documents/AllDocumentsSearchableList.vue";

  import { Document, User, Company} from "@/generated/graphql";
  import CardBodyLink from "@/components/card/CardBodyLink.vue";
  import RouteNames from "@/entities/RouteNames";
  import DocumentItem from "@/components/documents/DocumentItem.vue";
  import { defaultCollectionQuery } from "@/data/paginationConfig";
  import GET_COMPANIES from "@/apollo/company/GetCompanies.gql";
  import paginationConfig from "@/data/paginationConfig";
  import PaginationConfig from "@/entities/PaginationConfig";
  
  @Component({
    components: {
      DocumentItem,
      CardBodyLink,
      AllDocumentsSearchableList,
    },
    apollo: {
      companies: {
        query: GET_COMPANIES,
        variables() {
          return this.companiesQuery;
        },
        update(data) {
          this.paginationConfig.total = data.total.aggregate.count;
          this.paginationConfig.loadedCount = data.companies.length;
          return data.companies;
        },
      },
    },
  })
  export default class DocumentsContractorAll extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    companies?: Company[];
    RouteNames: typeof RouteNames = RouteNames
    paginationConfig: PaginationConfig = { ...paginationConfig };

    get query(): Object {
      const companiesIds = this.companies?.map(company => company.id) || [];
      if (companiesIds.length) {
        return {
          // company_id: { _in: companiesIds },
          uploaded_by: { _eq: this.currentUser.id },
        };
      }
      return { uploaded_by: { _eq: this.currentUser.id } };
    }
    get companiesQuery(): Object {
      const { page, limit } = this.paginationConfig;
      const nextOffset = page * limit - limit;
      const params = {
        offset: nextOffset,
        limit: limit,
      };

      const conditions: any[] = [
        {
          contractors: {
            user_id: { _eq: this.currentUser.id },
            deleted: { _eq: false },
            approved: { _eq: true },
          },
        },
      ];


      return {
        where: { _and: conditions },
        ...params,
        userId: this.currentUser.id,
      };
    }
    getAttachedToApplications(document: Document): string {
      const count = document.applications_aggregate!.aggregate!.count || 0;
      const end = count > 1 ? 's' : '';
      return `${count} application${end}`;
    }

    getRouteQuery(document: Document): { breadcrumb_title: string, filter_by_document_id: string } {
      return {
        breadcrumb_title: `With '${document.filename}' document attached`,
        filter_by_document_id: document.id,
        ...defaultCollectionQuery,
      };
    }

    isAttachedToApplication(document: Document): boolean {
      return Boolean(document.applications_aggregate?.aggregate?.count);
    }

    isProjectExist(document: Document): boolean {
      return document.document_projects.length > 0
    }

    isDocumentFrozen(document: Document): boolean {
      return this.currentUser.id !== document.uploaded_by;
    }

    getProject(document: Document) {
      return document.document_projects[0].project;
    }

  }
